<template>
    <div>
        <div class="company">
            <img src="@/assets/images/company-banner.png" alt="">
        </div>

        <div class="news">
            <div class="news-conten">
                <div class="news-left">
                    <div class="news-title">
                        <div class="title-item">
                            <a href="">全部</a>
                        </div>
                        <div class="title-item">
                            <a href="">行业方案</a>
                        </div>
                        <div class="title-item">
                            <a href="">公司动态</a>
                        </div>
                     
                    </div>

                    <div class="left-lists">
                        <div @click="toPage('/detail',item.id)" class="left-list-item" v-for="(item,index) in lists" :key="index">
                            <div class="list-item-left">
                                <img :src="item.img_url" alt="">
                            </div>
                            <div class="list-item-right">
                                <div class="list-item-right-top">
                                    {{item.title}}
                                </div>
                                <div class="list-item-right-center">
                                    {{item.desc}}
                                </div>
                                <div class="list-item-right-bottom">
                                    <div>{{item.create_time}}</div>
                                    <!-- <div class="bottom-lll-num">
                                          <div class="bottom-lll-img">
                                            <img src="@/assets/images/liulan.png" alt="">
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>

                      
                    </div>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                         @current-change="handleCurrentChange"
                        :total="count">
                        </el-pagination>
                </div>
                <div class="news-right">
                   

                  <div>
                        <div class="news-right-title">
                            动态推荐
                        </div>
                        <div class="news-right-lists">
                            <div  v-for="(item,index) in limitNew" :key="index" class="news-right-item">
                                <a :href="'/detail?id=' + item.id"  >{{index + 1}}、{{item.title}}</a>
                            </div>
                        </div>
                    </div>

                   
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {getAllNews,limitData} from '@/api/index/index'
import router from '@/router'
    export default  {
        data() {
            return {
                page : 1,
                page_size : 8,
                count : 0,
                lists : [],
                limitNew : []
            }
        },
        created() {
            this.getNews()
            this.getLimitNew()
        },
        methods : {
            toPage(url,id) {
                router.push({path:url,query : {
                    id:id
                }})
            },
             handleCurrentChange(val) {
                this.page = val
                this.getNews()
            },
            getNews() {
                getAllNews({page : this.page,page_size : this.page_size}).then(res => {
                    this.count = res.data.count
                    this.lists = res.data.data
                    console.log(666,res)
                })
            },
            getLimitNew(){
                limitData({limit : 10}).then(res => {
                    this.limitNew = res.data
                })
            },
           
        }
    }
</script>
<style scoped>
.company{
    width: 100%;
}
.company img {
    min-width: 1380px;
    height: 550px;
}
.news{
   width: 100%; 
   height: 1806px;
}
.news-conten{
    width: 1380px;
    margin:  0 auto;
    display: flex;
}
.news-left{
    width: 935px;
    position: relative;
    height: 1600px;

}
::v-deep .el-pagination {
    margin-top:60px;
   
}
.news-title {
    width: 100%;
    height: 82px;
    border-bottom: 1px solid #D9D9D9;
    display: flex;
}
.title-item{
    margin-right: 100px;
    height: 78px;
    line-height: 82px;
}
.title-item a{
    color: #555555;
    font-size: 18px;
}
.title-item a:hover{
    color: #0075EA;
    font-weight: 400;
}
.title-item:hover{
    border-bottom: 4px solid #0075EA;
}
.left-list-item{
    display: flex;
    padding-top: 16px;
    padding-bottom: 14px;
    border-bottom: 1px solid #D9D9D9;
}
.list-item-right{
    width: 100%;
    margin-left: 17px;
    text-align: left;
}
.list-item-right-top{
    color: #333333;
    font-size: 24px;
    font-weight: 400;
}
.list-item-right-center{
    width: 650px;
    color: #888888;
    font-size: 16px;
    margin-top:14px;
    margin-bottom:14px;
}
.list-item-right-bottom{
    display: flex;
    justify-content: space-between;
}
.bottom-lll-num{
    position: relative;
}
.bottom-lll-img {
    width: 20px;
    height: 20px;
    position:absolute;
    left: -20px;
    top:0;
}
.bottom-lll-img img {
    width:20px;
}
.news-right-title{
    font-size: 18px;
    height: 78px;
    font-weight: 500;
    color: #000000;
    margin-left: 68px;
    line-height: 82px;
    border-bottom: 4px solid #0075EA;
}
.news-right-item{
    color: #555555;

}
.news-right-item a {
    color: #555555;
}
.news-right-item a:hover {
    color: #0075EA;
}
.news-right-lists{
    text-align: left;
    margin-left: 68px;
    margin-top: 17px;
    line-height: 26px;
}
.list-item-left img{
    width : 196px;
    height: 134px;
}
</style>
